import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'Ο LA Jackson ιδρύει την εταιρεία London Rubber Company και πωλεί εισαγόμενα προφυλακτικά και αξεσουάρ.',
		},
		{
			year: 1929,
			description: 'Η εταιρεία London Rubber Company (LRC) καταχωρεί το εμπορικό σήμα της Durex.',
		},
		{
			year: 'Δεκαετία του 1950',
			description: 'Η Durex λανσάρει το πρώτο «υγρό» προφυλακτικό.',
		},
		{
			year: 1953,
			description: 'Η Durex είναι η πρώτη μάρκα που αναπτύσσει και χρησιμοποιεί ηλεκτρονικούς ελέγχους.',
		},
		{
			year: 'Δεκαετία του 1960',
			description: 'Η Durex λανσάρει το πρώτο προφυλακτικό με ανατομικό σχήμα.',
		},
		{
			year: 'Δεκαετία του 1990',
			description: 'Η Durex είναι η πρώτη μάρκα προφυλακτικού που υιοθετεί παγκόσμια «σφραγίδα ποιότητας» ως πρότυπο',
		},
		{
			year: 1995,
			description: 'Η Durex λανσάρει μια σειρά από πολύχρωμα και αρωματισμένα (με γεύσεις) προφυλακτικά.',
		},
		{
			year: 1996,
			description: 'Η Durex είναι η πρώτη μάρκα προφυλακτικού που δημιουργεί ιστοσελίδα. Τώρα έχουμε 42 διαφορετικές ιστοσελίδες για τις χώρες όπου εκπροσωπούμαστε.',
		},
		{
			year: 1997,
			description: 'Η Durex λανσάρει προφυλακτικά χωρίς λάτεξ. Ένα νέο, μη αλλεργιογόνο υλικό χρησιμοποιείται για το νέο προϊόν: η συνθετική πολυουρεθάνη που αναπτύχθηκε από την Durex είναι πιο μαλακή και πιο ελαστική από το λάτεξ φυσικού καουτσούκ',
		},
		{
			year: 1998,
			description: 'Η Durex είναι η πρώτη μάρκα προφυλακτικού που διεξάγει και δημοσιεύει παγκόσμια έρευνα σεξουαλικής ευεξίας.',
		},
		{
			year: 2001,
			description: 'Η Durex παρουσιάζει το Pleasuremax. Αυτό καθιστά την Durex την πρώτη μάρκα προφυλακτικού που κυκλοφορεί στην αγορά προφυλακτικό με κουκκίδες και ραβδώσεις.',
		},
		{
			year: 2003,
			description: 'Η Durex λανσάρει τη συναρπαστική σειρά λιπαντικών Play.',
		},
		{
			year: 2005,
			description: 'Το Durex Network παρουσιάζει τις εκθέσεις Face of Global Sex, οι οποίες διερευνούν πτυχές της σεξουαλικής συμπεριφοράς και συντάσσονται για την ενημέρωση των ακαδημαϊκών και των υπεύθυνων χάραξης πολιτικής.',
		},
		{
			year: 2008,
			description: 'Προκειμένου να προωθήσει το ασφαλές σεξ μεταξύ των νέων, η Durex ενθαρρύνει τους νέους ηλικίας μεταξύ 16 και 24 ετών να δημιουργήσουν μια πρωτότυπη αφίσα για τη σεξουαλική υγεία - μια αφίσα εφήβων για εφήβους.',
		},
		{
			year: 2009,
			description: 'Η Durex κλείνει τα 80!',
		},
		{
			year: 2010,
			description: 'Η Durex υποστηρίζει την πρωτοβουλία “Condomize!" του Ταμείου Πληθυσμού των Ηνωμένων Εθνών στο Διεθνές Συνέδριο για το AIDS στην Βιέννη δωρίζοντας 220,000 προφυλακτικά.',
		},
		{
			year: 2010,
			description: 'Η Durex αγοράζεται από την Reckitt Benckiser.',
		},
		{
			year: 2010,
			description: 'Η Durex παρουσιάζει το Performax Intense, ένα προφυλακτικό σχεδιασμένο να βοηθά στην αμοιβαία κορύφωση. Με εσωτερική επίστρωση που περιέχει 5% βενζοκαΐνη και εξωτερική διεγερτική υφή, μπορεί να συμβάλει σε μεγαλύτερης διάρκειας και πιο έντονο σεξ.',
		},
		{
			year: 2019,
			description: 'Η Durex κλείνει τα 90!',
		},
	]
}